import { render, staticRenderFns } from "./EmptyRow.vue?vue&type=template&id=cf2043a6"
import script from "./EmptyRow.vue?vue&type=script&lang=js"
export * from "./EmptyRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports